import PoppinsBold from '@assets/fonts/Poppins-Bold.ttf';
import PoppinsSemiBold from '@assets/fonts/Poppins-SemiBold.ttf';
import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'PoppinsSemi',
  fonts: [
    { src: PoppinsSemiBold },
    { src: PoppinsSemiBold, fontWeight: 'bold' },
  ],
});
Font.register({
  family: 'PoppinsBold',
  fonts: [{ src: PoppinsBold }, { src: PoppinsBold, fontWeight: 'bold' }],
});
export const styles = StyleSheet.create({
  reviewJobSectionHeadingText: {
    fontSize: '10px',
    fontWeight: 700,
    color: 'black',
    fontFamily: 'PoppinsSemi',
  },
  reviewJobBottomMarginView: {
    marginBottom: '25px',
  },
  reviewJobRightMarginView: {
    marginRight: '15px',
  },
  reviewJobRowIdPoNumberInnerBox: {
    width: '100%',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    lineHeight: '1.5px',
  },
  reviewJobCheckIcons: {
    width: '10px',
    height: '10px',
    marginRight: '6px',
  },
  page: {
    backgroundColor: 'white',
  },
  sectionsHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  sectionHeading: {
    marginLeft: 20,
    marginRight: 20,

    fontSize: '14px',
    fontWeight: 'black',
    borderBottom: '3px solid black',
    marginTop: '20px',
    fontFamily: 'PoppinsSemi',
  },
  sectionHeadingBanner: {
    marginLeft: 20,
    marginRight: 20,
    color: 'white',
    // padding: '10px 10px',
    height: '35px',
    fontSize: '16px',
    // fontWeight: 'bold',
    fontFamily: 'PoppinsSemi',
    backgroundColor: '#E61D2A',
    marginBottom: '10px',
    minHeight: '40px',

    textTransform: 'capitalize',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionHeadingText: {
    fontSize: '12px',
    fontWeight: 'bold',
  },
  logoImage: {
    height: '70px',
    width: '120px',
  },
  sections: {
    margin: 10,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '22px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '10px',
    // width: '100%',
  },
  sectionOverallRating: {
    marginLeft: 20,
    marginRight: 20,
    border: '1px solid black',
    marginTop: '10px',
    width: '555px',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'row',
  },
  sectionOverallRatingBox: {
    // border: '1px solid lightgray',
    padding: '20px 10px',
    width: '15%',
    fontSize: '24px',
  },
  sectionMessage: {
    marginLeft: '15px',
    fontSize: '12px',
    // textAlign: 'center',
    padding: '20px 0px',
    width: '400px',
    height: '100%',
  },
  ratingCriteriaOptionContainer: {
    marginLeft: 20,
    marginRight: 20,
    width: '555px',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'column',
    // textAlign: 'center',
    // marginTop: '10px',
  },
  ratingCriteriaOptionBox: {
    border: '1px solid black',
    // padding: '10px 10px',
    textAlign: 'center',
    width: '15%',
    height: '50px',
    fontSize: '24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ratingCriteriaOptionHeading: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontFamily: 'PoppinsSemi',
  },
  ratingCriteriaOptionHeadingBox: {
    marginLeft: 20,
    marginRight: 20,
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: '20px',
    fontFamily: 'PoppinsSemi',
  },
  r8trCommentsContainer: {
    marginLeft: 20,
    marginRight: 20,
    border: '1px solid black',
    width: '555px',
    fontSize: '12px',
    display: 'flex',
    flexDirection: 'row',
    // textAlign: 'center',
    marginTop: '10px',
    padding: '10px 20px',
  },
  sectionContainerVideo: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    padding: '15px 22px',
  },
  sectionTableVideo: {
    flex: '0 0 33.3333%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '5px',
    marginRight: '5px',
  },
  sectionTable: {
    padding: '10px 20px',
    width: '25%',
    fontSize: '14px',
  },
  sectionTableJob: {
    padding: '10px 20px',
    width: '15%',
    fontSize: '14px',
  },
  sectionTableIn: {
    padding: '10px 10px',
    width: '35%',
    fontSize: '14px',
  },
  sectionTableRating: {
    border: '1px solid lightgray',
    padding: '10px 20px',
    width: '80%',
  },
  sectionTableHead: {
    fontSize: '10px',
    fontWeight: 'bold',
    fontFamily: 'PoppinsSemi',
  },
  text: {
    fontSize: '12px',
    marginTop: '5px',
    color: '#414042',
  },
  ratingCriteriaOptionValue: {
    fontSize: '12px',
    color: '#414042',
  },
  textBold: {
    fontWeight: 'black',
    fontSize: '20px',
    fontFamily: 'PoppinsBold',
  },
  images: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
  },
  sectionLink: {
    color: '#E61D2A',
    textDecoration: 'underline',
  },
  firstContainer: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  secondContainer: {
    marginTop: '50px',
  },
  topMarginView: {
    marginTop: '20px',
  },
  ratingCriteriaOptionsTypeHeading: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginTop: '10px',
    marginBottom: '10px',
  },
  ratingCriteriaOptionMianContainer: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  ratingCriteriaUpperBox: {
    // marginLeft: 15,
    border: '1px solid black',
    width: '100%',
    fontSize: '12px',
    padding: '10px 2px',
  },
  ratingCriteriaOptionImageTitleBox: {
    marginTop: 15,
    border: '1px solid black',
    width: '40%',
    fontSize: '12px',
    padding: '10px 2px',
  },
  sectionContainerImages: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    padding: '15px 0px',
  },
  sectionInnerContainerImage: {
    flex: '0 0 33.3333%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
  },
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
});
export interface PdfImage {
  id?: string | number;
  url?: string;
}

export interface PdfNestedValue {
  value?: string | number | boolean | { address?: string } | PdfImage[];
}

export type PdfOptionValue = string | number | PdfNestedValue;

export interface PdfOption {
  id: string | number;
  type?: string;
  ratingTitle?: string;
  parentValue?: string | number;
  value?: PdfOptionValue;
}

export interface PdfCriteria {
  id: string | number;
  title?: string;
  options: PdfOption[];
  damages: { id: string | number; title?: string }[];
  criteriaInfo?: string;
  images?: PdfImage[];
}

export interface JobPdfDetails {
  id?: string | number;
  ratingStartedAt?: string;
  buyer?: string;
  r8tr?: string;
  year?: string | number;
  make?: string;
  model?: string;
  vinOrSerial?: string;
  overAllComments?: string;
  ratingCriterias?: PdfCriteria[];
}

const isNestedValue = (
  value: PdfOptionValue | undefined
): value is PdfNestedValue => {
  return typeof value === 'object' && value !== null;
};

export const formatOptionScore = (option: PdfOption): string | number => {
  const current = !isNestedValue(option.value) ? option.value ?? '' : '';
  if (option.parentValue) {
    return `${current}/${option.parentValue}`;
  }
  return current;
};

export const plainOptionValue = (option: PdfOption): string | number => {
  return !isNestedValue(option.value) ? option.value ?? '' : '';
};

export const nestedScalar = (option: PdfOption): string | number => {
  if (!isNestedValue(option.value)) return '';
  const nested = option.value.value;
  if (typeof nested === 'string' || typeof nested === 'number') return nested;
  return '';
};

export const nestedAddress = (option: PdfOption): string => {
  if (!isNestedValue(option.value)) return '';
  const nested = option.value.value;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested.address ?? '';
  }
  return '';
};

export const nestedChecked = (option: PdfOption): boolean => {
  return isNestedValue(option.value) && option.value.value === true;
};

export const pdfPhotoStyle = (border: string, boxShadow: string) => {
  return {
    width: '180px',
    height: '200px',
    border,
    objectFit: 'cover' as const,
    boxShadow,
  };
};

export const nestedImages = (option: PdfOption): PdfImage[] => {
  if (!isNestedValue(option.value) || !Array.isArray(option.value.value)) {
    return [];
  }
  return option.value.value;
};
